module.exports = __webpack_public_path__ + "media/img/vca/prizes/tbakery-db1a15318b802e56a252201f6d9e8e11.png";